// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4210":"2e257208","6106":"8af04ff9"}[chunkId] + ".chunk.css";
};